<template>
  <div>
    <a-row class="mb-3">
      <a-col :xs="24" :md="10" :lg="8">
        <a-input
          v-model:value="featureSearch"
          placeholder="Search features"
          allow-clear
        />
      </a-col>
    </a-row>

    <a-table
      :columns="columns"
      :data-source="visibleFeatures"
      :loading="isLoadingAdminFeatureControl && !adminFeatures.length"
      :pagination="{ pageSize: 20, hideOnSinglePage: true }"
      row-key="id"
      bordered
    >
      <template #bodyCell="{ record, column }">
        <template v-if="column.key === 'feature'">
          <div class="feature-name">{{ record.name }}</div>
          <div class="text-secondary">{{ featureDescription(record) }}</div>
        </template>

        <template v-if="column.key === 'status'">
          <a-tag v-if="record.suppressed" color="red">
            Disabled for everyone
          </a-tag>
          <a-tag v-else color="green">Active</a-tag>
        </template>

        <template v-if="column.key === 'organizations'">
          {{ record.suppressed ? 'Kept for' : 'Enabled for' }}
          {{ organizationCountText(record) }}
          <div v-if="record.suppressed" class="text-secondary">
            Inactive until re-enabled
          </div>
        </template>

        <template v-if="column.key === 'actions'">
          <a-button
            v-if="record.suppressed"
            :loading="!!busy[`feature:${record.id}`]"
            @click="reEnable(record)"
          >
            Re-enable
          </a-button>
          <a-button
            v-else
            danger
            :loading="!!busy[`feature:${record.id}`]"
            @click="confirmDisableForEveryone(record)"
          >
            <template #icon><stop-outlined /></template>
            Disable for everyone
          </a-button>
        </template>
      </template>

      <template #expandedRowRender="{ record }">
        <feature-organizations
          :feature="record"
          :subscriptions="subscriptionsOf(record)"
          :organization-options="organizationOptions"
          :busy="busy"
          @enable="
            ({ organization, organizationName }) =>
              enableForOrganization(record, organization, organizationName)
          "
          @remove="removeAccess"
        />
      </template>

      <template #emptyText>
        <a-empty
          :description="
            adminFeatures.length
              ? 'No features match your search.'
              : 'No features yet. Use Add Feature to create one.'
          "
        />
      </template>
    </a-table>
  </div>
</template>

<script>
import { StopOutlined } from '@ant-design/icons-vue';
import featureControlMixin from './featureControlMixin';
import FeatureOrganizations from './FeatureOrganizations.vue';

export default {
  name: 'FeatureControlByFeature',
  components: { FeatureOrganizations, StopOutlined },
  mixins: [featureControlMixin],
  data() {
    return {
      featureSearch: '',
      columns: [
        { title: 'Feature', key: 'feature' },
        { title: 'Status', key: 'status', width: 190 },
        { title: 'Organizations', key: 'organizations', width: 220 },
        { title: 'Actions', key: 'actions', width: 220 },
      ],
    };
  },
  computed: {
    visibleFeatures() {
      const search = this.featureSearch.trim().toLowerCase();
      if (!search) return this.sortedFeatures;
      return this.sortedFeatures.filter((feature) =>
        `${feature.name} ${this.featureDescription(feature)}`
          .toLowerCase()
          .includes(search)
      );
    },
  },
};
</script>

<style scoped>
.feature-name {
  font-weight: 600;
}
</style>
